<template>
  <img
    v-if="loader"
    :src="'/images/default-loader.png'"
    :class="classes"
    :style="styles"
    style="object-fit: contain;"
    :alt="altText"
    ref="img1"
    @error="imageUrlAlt"
  />
  <img
    v-else-if="!loader && urlReceiveFlag"
    :src="signedUrl"
    :alt="altText"
    @click="$emit('click')"
    :style="styles"
    :class="classes"
    ref="img2"
    @error="imageUrlAlt"
  />
  <img
    v-else-if="typeof src === 'undefined'"
    src="/images/default-user.png"
    :alt="altText"
    :style="styles"
    :class="classes"
    @error="imageUrlAlt"
    ref="img3"
  />
  <img 
    v-else 
    :src="newSrcImage" 
    :alt="altText" 
    :class="classes" 
    :style="styles" 
    @click="$emit('click')"
    @error="imageUrlAlt"
    ref="img4"
    v-imageLoadCompleted="loadState"
  />
    <!-- @load="evt => loadState = evt.eventPhase"  -->
</template>

<script>
import config from "@/config.js";
export default {
  props: ["src", "styles", "classes"],
  directives: {
    imageLoadCompleted: (el, binding) => {
       if (el.complete) {
         binding.value = true;
       }
    },
  },
  data: function() {
    return {
      signedUrl: "",
      urlReceiveFlag: false,
      newSrcImage: "",
      loader: false,
      altText: "image",
      loadState: false,
    };
  },
  watch: {
    src: {
      handler(newValue) {
        if (newValue) {
          this.checkSrc();
        }
      }
    },
    loadState: {
      handler(nv) {
        console.log("gg: ", nv);
      }
    },
  },
  mounted() {
    // if (!this.src || this.src == "") return;
    this.checkSrc();
  },
  methods: {
    imageUrlAlt() {
      event.target.src = "/images/default-user.png"
    },
    checkSrc() {
      if (this.src && this.src != "" && this.src.includes("amazonaws.com")) {
        this.urlReceiveFlag = true;
        this.loader = true;
        this.loadImage();
      } else if (this.src && this.src.includes("blob")) {
        this.urlReceiveFlag = false;
        this.newSrcImage = this.src;
      } else {
        this.urlReceiveFlag = false;
        this.newSrcImage = this.src;
      }
    },
    loadImage() {
      let url = `${config.NEW_BASE_URL}api/v2/signed-resource?s3Url=${this.src}`;
      this.$http
        .get(url)
        .then(response => {
          this.loader = false;
          this.signedUrl = response.body.signedUrl;
        })
        .catch(error => {
          this.signedUrl = "/images/default-user.png";
        });
    }
  }
};
</script>

<style>
</style>
